import type { PostNode, ShortCode } from '@highereducation/wordpress';
import { RankingsAdapter } from './RankingsAdapter';

export { RankingsAdapter } from './RankingsAdapter';
export type { RankingsAdapterProps } from './RankingsAdapter';

/**
 * Derive the tenant domain name for the advertising-disclosure tooltip from
 * the post's resolved site settings (EDUN-13115). `domainLabelWithExtension`
 * is the exact field the legacy `se-supersonic-ui` `Tooltip/Disclosure` read
 * from `MobiusContext`, so the HEN disclosure names the correct domain for
 * every tenant — no per-tenant `sitename` content migration required. Falls
 * back to `name` when the label is absent; when neither is present the adapter
 * fails over to the `sitename` shortcode attribute and finally to "This site".
 */
function getDisclosureSiteName(post: PostNode): string | undefined {
  const config = post?.siteSettings;
  return config?.domainLabelWithExtension || config?.name || undefined;
}

export const RankingsShortcode: ShortCode = {
  component: RankingsAdapter as ShortCode['component'],
  getPropsFromMeta: (post) => ({
    disclosureSiteName: getDisclosureSiteName(post),
  }),
};
